var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { RfpProfessionalNegotiableTag } from '@/components/modules/pages/rfp/professional/Tag/RfpProfessionalNegotiableTag';
import { Text } from '@/components/ui/Typography/Body/Text';
import { getProfessionalRfpBudgetText } from '@/utils/modules/rfp/professional/budget';
export const RfpProfessionalBudgetText = (props) => {
    const { budget, className, isNegotiable = false, maxBudget, unit } = props, args = __rest(props, ["budget", "className", "isNegotiable", "maxBudget", "unit"]);
    const text = useMemo(() => getProfessionalRfpBudgetText({ budget, maxBudget, unit }), [budget, maxBudget, unit]);
    return (_jsxs("div", Object.assign({ className: clsx('flex items-center', className) }, { children: [_jsx(Text, Object.assign({ color: 'base', isBold: true }, args, { children: text })), (budget || maxBudget) && isNegotiable && (_jsx(RfpProfessionalNegotiableTag, { className: 'ml-12 shrink-0' }))] })));
};
